// BrimLight/client/ui/ProjectGallery.js
import { ComponentBase } from "../core/ComponentBase.js";

export class ProjectGallery extends ComponentBase {
    constructor(config) {
        super(config);
        this.dataCrud = null;
    }

    async initialize() {
        this.dataCrud = await this.createManagedComponent("DataCrud", null, {
            instanceId: `${this.config.instanceId}-crud`,
            rpcClass: "VideoProjectRpc",
            schemaPath: "collections/videoProjects",
            title: "My Video Projects",
            viewConfig: {
                mode: 'card', // Use card view for a gallery look
                fields: [
                    { name: 'name', label: 'Project Name', isTitle: true },
                    { name: 'status', label: 'Status', render: (val) => `<span class="badge bg-primary">${val.replace('_', ' ')}</span>` },
                    { name: 'createdAt', label: 'Created', render: (val) => new Date(val).toLocaleDateString() },
                ],
                actions: [
                    { label: 'Open Editor', icon: 'bi-pencil-square', eventName: 'openProject' }
                ],
                toolbar: {
                    create: { enabled: false } // Disable default create, handled by ProjectSelector
                }
            },
            dataConfig: {
                autoLoad: false
            }
        });

        this.dataCrud.dataView.on('openProject', (item) => {
            // This event will be caught by the mainLayout to navigate to the editor
            this.emit('projectSelected', { projectId: item._id });
        });

        await super.initialize();
    }

    async initAfterLogin() {
        if (this.dataCrud) {
            await this.dataCrud.refreshData();
        }
    }

    async render() {
        return this.dataCrud.render();
    }
}